'use strict';

var aviaryColors = {};

exports.__exports = aviaryColors;
//# sourceMappingURL=aviaryColors.cjs.map
